import React from "react";
import { connect } from "react-redux";
import {
  getArticles,
  getCategories,
  getAuthors,
  createArticle,
  removeArticle,
} from "../../actions/articles";
import { subArticle } from "../../actions/sub";
import {
  Container,
  Card,
  CardHeader,
  CardFooter,
  Button,
  UncontrolledAlert,
  Modal,
} from "reactstrap";
import qs from "query-string";
import { Link } from "react-router-dom";
import ReactBSAlert from "react-bootstrap-sweetalert";
import DropdownSelection from "../../components/Commons/DropdownSelection";
import AuthorSelection from "../../components/articles/AuthorSelection";
import SearchBar from "../../components/Commons/SearchBar";
import ArticleTable from "../../components/articles/ArticleTable";
import PaginationBar from "../../components/Commons/PaginationBar";
import NewModal from "../../components/articles/NewModal";
const CATEGORIES = [
  {
    id: 1,
    parent_id: null,
    sort: null,
    name: "news",
    display_name: "新聞",
  },
  {
    id: 101,
    parent_id: null,
    sort: null,
    name: "events",
    display_name: "活動",
  },
  {
    id: 105,
    parent_id: null,
    sort: null,
    name: "business info",
    display_name: "商業",
  },
  {
    id: 108,
    parent_id: null,
    sort: null,
    name: "lives",
    display_name: "生活資訊",
  },
  {
    id: 114,
    parent_id: null,
    sort: null,
    name: "southern plaza",
    display_name: "美南廣場",
  },
];
class ArticlesPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      per_page: 7,
      alert: "",
      openUserModal: false,
      selectedUser: {},
      activeCategoryType: null,
      selects: {},
      operationModal: false,
      operationNewModal: false,
      article: {
        category_ids: [],
      },
    };
    this.goToPage = this.goToPage.bind(this);
    this.onSearchInputChange = this.onSearchInputChange.bind(this);
    this.filterCat = this.filterCat.bind(this);
    this.filterAuthor = this.filterAuthor.bind(this);
    this.getCurrentCategory = this.getCurrentCategory.bind(this);
    this.toggleSelectEvent = this.toggleSelectEvent.bind(this);
    this.toggleModal = this.toggleModal.bind(this);
    this.togglemark = this.togglemark.bind(this);
    this.toggleNewModal = this.toggleNewModal.bind(this);
    this.handleCheckBoxChange = this.handleCheckBoxChange.bind(this);
    this.submitArticle = this.submitArticle.bind(this);
    this.removeArticle = this.removeArticle.bind(this);
    this.hideAlert = this.hideAlert.bind(this);
  }

  componentDidMount() {
    let urlParams = qs.parse(this.props.search);
    let { category_id } = urlParams;
    const activeCategoryType = this.getCurrentCategory(category_id);
    this.setState({
      ...this.state,
      ...urlParams,
      activeCategoryType: activeCategoryType,
    });
    this.getCategories();
    this.getAuthors();
    this.getArticles({ ...urlParams });
  }

  componentWillReceiveProps(newProps) {
    if (newProps.location !== this.props.location) {
      let urlParams = qs.parse(newProps.search);
      this.getArticles(urlParams);
    }
  }

  getCurrentCategory(category_id) {
    var matchRoles = CATEGORIES.filter((value) => {
      return value.id == category_id;
    });
    console.log(CATEGORIES, category_id, matchRoles);
    var activeCategoryType = null;
    if (matchRoles.length) {
      activeCategoryType = matchRoles[0].display_name;
    }
    return activeCategoryType;
  }
  getAuthors() {
    this.props.getAuthors();
  }

  getCategories() {
    this.props.getCategories();
  }

  getArticles(params) {
    // let urlParams = qs.parse(this.props.search);
    let searchParams = {
      // ...urlParams,
      ...params,
    };
    this.props.getArticles(searchParams);
  }

  goToPage(page) {
    let urlParams = qs.parse(this.props.history.location.search);
    let searchParams = {
      ...urlParams,
      page,
    };
    this.props.history.push({
      pathname: this.props.pathname,
      search: "?" + qs.stringify(searchParams),
    });
  }
  hideAlert() {
    this.setState({
      alert: "",
    });
  }

  filterCat(category_id) {
    const activeCategoryType = this.getCurrentCategory(category_id);
    this.setState({
      activeCategoryType: activeCategoryType,
    });
    let urlParams = qs.parse(this.props.history.location.search);
    let searchParams = {
      ...urlParams,
      category_id,
    };
    this.props.history.push({
      pathname: this.props.pathname,
      search: "?" + qs.stringify(searchParams),
    });
  }

  filterAuthor(author_id) {
    // const activeCategoryType = this.getCurrentCategory(author_id);
    // this.setState({
    //   activeCategoryType: activeCategoryType
    // });
    let urlParams = qs.parse(this.props.history.location.search);
    let searchParams = {
      ...urlParams,
      author_id,
    };
    this.props.history.push({
      pathname: this.props.pathname,
      search: "?" + qs.stringify(searchParams),
    });
  }

  onSearchInputChange(e) {
    let searchStr = e.target.value;
    this.setState({
      title: searchStr,
    });
    let urlParams = qs.parse(this.props.history.location.search);
    let searchParams = {
      ...urlParams,
      title: searchStr,
      page: 1,
    };
    delete searchParams.page;
    this.props.history.push({
      pathname: this.props.pathname,
      search: "?" + qs.stringify(searchParams),
    });
  }

  toggleSelectEvent(checked, index) {
    let selects = this.state.selects;
    selects[index] = checked;
    this.setState({
      selects,
    });
  }

  toggleModal = (state) => {
    this.setState({
      operationModal: !this.state.operationModal,
    });
  };

  togglemark(type, mark) {
    let selects = this.state.selects;
    let post_category_join_ids = [];
    Object.keys(selects).forEach(function (key) {
      if (selects[key]) {
        post_category_join_ids.push(parseInt(key));
      }
    });
    this.props.subArticle({
      type,
      mark,
      post_category_join_ids,
    });
    this.setState({
      operationModal: !this.state.operationModal,
      selects: [],
    });
  }

  toggleNewModal = (state) => {
    this.setState({
      operationNewModal: !this.state.operationNewModal,
    });
  };

  handleCheckBoxChange(e) {
    const { checked, value } = e.target;
    let article = this.state.article;
    if (checked && article.category_ids.indexOf(value) === -1) {
      article.category_ids.push(parseInt(value));
    } else {
      article.category_ids = article.category_ids.filter(
        (id) => id !== parseInt(value)
      );
    }
    this.setState({
      article: article,
    });
  }

  submitArticle() {
    let { article } = this.state;
    const category_ids = article.category_ids;
    this.props.createArticle({
      category_ids,
    });
  }

  confirmedRemove(row) {
    this.setState({
      alert: "",
    });
    this.props.removeArticle(row.post.id);
  }

  removeArticle(row) {
    this.setState({
      alert: (
        <ReactBSAlert
          warning
          title={`刪除文章 ${row.post.title}?`}
          style={{ backgroundColor: "#ffffff" }}
          onCancel={() => this.hideAlert()}
          onConfirm={() => this.confirmedRemove(row)}
          showCancel
          cancelBtnBsStyle="default"
          cancelBtnText="取消"
          confirmBtnBsStyle="primary"
          confirmBtnText="是的，刪除！"
          btnSize=""
        >
          <small>刪除操作將無法取消</small>
        </ReactBSAlert>
      ),
    });
  }

  render() {
    const {
      articles,
      articlesPagination,
      getArticlesRequest,
      categories,
      authors,
      errorMsg,
      successBackMsg,
      editArticleRequest,
      getArticleRequest,
    } = this.props.articles;
    var activeCategoryType = this.state.activeCategoryType;
    var activeAuthorType = this.state.activeAuthorType;
    const heads = ["狀態", "標題", "分類", "作者", "發布日期", "操作"];
    const dataAttributes = [
      "status",
      "title",
      "category",
      "author",
      "created_at",
    ];

    return (
      <Container className="mt-4" fluid>
        {this.state.alert}
        {errorMsg && (
          <UncontrolledAlert color="danger" fade={false}>
            <span className="alert-inner--text mb-4">{errorMsg}</span>
          </UncontrolledAlert>
        )}
        {successBackMsg && (
          <UncontrolledAlert color="success" fade={false}>
            <span className="alert-inner--text mb-4">{successBackMsg}</span>
          </UncontrolledAlert>
        )}
        <Card className="card-frame">
          <CardHeader className="border-0">
            <div className="d-flex align-items-center justify-content-between">
              <div>
                <DropdownSelection
                  Types={categories}
                  activeType={activeCategoryType}
                  filterType={this.filterCat}
                />
                {/* <AuthorSelection
                  Types={authors}
                  activeType={activeAuthorType}
                  filterType={this.filterAuthor}
                /> */}
              </div>
              <div className="d-flex align-items-center">
                <SearchBar
                  search_string={this.state.title}
                  onSearchInputChange={this.onSearchInputChange}
                />
                <Button
                  className="btn btn-default"
                  // tag={Link}
                  // to={"/admin/articles/new"}
                  onClick={this.toggleNewModal}
                >
                  写文章
                </Button>
              </div>
            </div>
          </CardHeader>
          <ArticleTable
            heads={heads}
            dataAttributes={dataAttributes}
            rows={articles}
            loading={getArticlesRequest}
            toggleSingle={this.toggleSelectEvent}
            selects={this.state.selects}
            toggleModal={this.toggleModal}
            remove={this.removeArticle}
          />
          <CardFooter className="py-4 d-flex justify-content-center">
            {articlesPagination.currentPage ? (
              <PaginationBar
                currentPage={articlesPagination.currentPage}
                totalPages={articlesPagination.lastPage}
                pageNeighbours={1}
                goToPage={(page) => this.goToPage(page)}
              />
            ) : null}
          </CardFooter>
        </Card>
        <Modal
          className="modal-dialog-centered modal-sm"
          isOpen={this.state.operationModal}
          toggle={() => this.toggleModal()}
        >
          <div className="modal-header">
            <button
              aria-label="Close"
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={() => this.toggleModal()}
            >
              <span aria-hidden={true}>×</span>
            </button>
          </div>
          <div className="modal-body d-flex flex-column justify-content-center align-items-center">
            {this.props.sub.errorMsg}
            <Button
              className="my-2 px-4"
              color="default"
              outline
              type="button"
              onClick={() => this.togglemark("is_push_selected", 1)}
            >
              添加訂閱推送
            </Button>
            <Button
              className="my-2 px-4"
              color="default"
              outline
              type="button"
              onClick={() => this.togglemark("is_headlined", 1)}
            >
              添加置頂文章
            </Button>
            <Button
              className="my-2 px-4"
              color="default"
              outline
              type="button"
              onClick={() => this.togglemark("is_headlined", 0)}
            >
              取消置頂文章
            </Button>
            <Button
              className="my-2 px-4"
              color="default"
              outline
              type="button"
              onClick={() => this.togglemark("is_frontpaged", 1)}
            >
              添加熱門頭條
            </Button>
            <Button
              className="my-2 ml--1 px-4"
              color="default"
              outline
              type="button"
              onClick={() => this.togglemark("is_frontpaged", 0)}
            >
              取消熱門頭條
            </Button>
          </div>
        </Modal>
        <NewModal
          data={this.state.article}
          handleCheckBoxChange={this.handleCheckBoxChange}
          submitArticle={this.submitArticle}
          loading={editArticleRequest}
          toggleNewModal={this.toggleNewModal}
          operationNewModal={this.state.operationNewModal}
        />
      </Container>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    articles: state.articles,
    sub: state.sub,
    location: state.router.location,
    pathname: state.router.location.pathname,
    search: state.router.location.search,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getArticles: (params) => dispatch(getArticles(params)),
    getCategories: (params) => dispatch(getCategories(params)),
    getAuthors: (params) => dispatch(getAuthors(params)),
    createArticle: (params) => dispatch(createArticle(params)),
    subArticle: (params) => dispatch(subArticle(params)),
    removeArticle: (params) => dispatch(removeArticle(params)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ArticlesPage);
